/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Vue, Component } from 'vue-property-decorator';
import NavBar from '@/components/nav-bar';

const style = require('./index.module.scss');
const vsImg = require('./images/vs.png');
const example1Img = require('./images/example-1.png');
const example2Img = require('./images/example-2.png');
const example3Img = require('./images/example-3.png');

@Component({ name: 'AccountTypeInfo' })
export default class AccountTypeInfo extends Vue {
  private navUpdate = 0;

  /**
   * 沉浸式页面，初始状态导航栏背景透明无标题
   * 监听滚动超过一定数值时，导航栏背景变成白色并显示标题
   */
  private listenScroll() {
    const { scrollY } = window;
    const { meta: routeMeta } = this.$route;
    if (scrollY >= 88) {
      routeMeta.navBarCustomProps.background = '#fff';
      routeMeta.title = '什么是I类户卡';
      this.navUpdate = 88;
    } else {
      routeMeta.navBarCustomProps.background = `rgba(255, 255, 255, ${scrollY / 88})`;
      routeMeta.title = '';
      this.navUpdate = scrollY;
    }
  }

  private mounted() {
    document.addEventListener('scroll', this.listenScroll);
  }

  private destroyed() {
    document.removeEventListener('scroll', this.listenScroll);
  }

  private render() {
    return (
      <div class={style.container}>
        <NavBar show={true} textAlign="center" key={this.navUpdate}></NavBar>
        <div class={style.mainTitle}>什么是I类户卡</div>
        <div class={style.subTitle}>建议添加I类储蓄卡，无交易限额，放款更顺利</div>
        <div class={style.exampleBg} />
        <div class={style.question}>
          <div class={style.title}>
            <span class={[style.icon, style.questionIcon1]} />
            <p>什么是I类卡？与其他类型差异有哪些？</p>
          </div>
          <div class={[style.answerContent, style.onlyOne]}>
            根据不同使用需求和风险控制，银行卡可分为：I类户、II类户、III类户，主要差异如下：
          </div>
          <div class={style.vsImgWrapper}>
            <img src={vsImg} class={style.exampleImg} alt="" />
          </div>
        </div>
        <div class={style.question}>
          <div class={style.title}>
            <span class={[style.icon, style.questionIcon2]} />
            <p>如何判断是I类户 还是II/III类户？</p>
          </div>
          <div class={style.answerContent}>
            打开银行APP，在【我的-银行卡】/【我的账户】页面中可查看账户类型，如下图：
          </div>
          <div class={style.exampleImgWrapper}>
            <img src={example3Img} class={style.exampleImg} alt="" />
            <img src={example1Img} class={style.exampleImg} alt="" />
            <img src={example2Img} class={style.exampleImg} alt="" />
          </div>
          <div class={style.answerContent}>您也可以拨打银行客服电话，询问客服查询对应账户类型</div>
        </div>
        <div class={style.question}>
          <div class={style.title}>
            <span class={[style.icon, style.questionIcon3]} />
            <p>如何将II/III级户 升级为I类户？</p>
          </div>
          <div class={style.answerContent}>前往发卡银行柜台/银行app上进行升级</div>
          <div class={style.answerContent}>满足一定的条件，如账户内余额、交易记录等(具体以发卡行要求为准)</div>
        </div>
        <div class={style.remark}>
          <p>* 借款时请确保：</p>
          <p>1. 绑定的银行卡状态正常，无异常交易/冻结</p>
          <p>2. 交易环境安全，避免泄露银行卡信息下或进行不安全交易</p>
        </div>
      </div>
    );
  }
}
